export default __webpack_public_path__ + "static/media/HippyEric400.bed1bd2d.jpg";